import type { DefaultTheme } from 'styled-components';

import { MarkerSelectValue } from './types.ts';

export interface ColorSetProps {
  theme: DefaultTheme;
}

const markerColors = {
  [MarkerSelectValue.NEUTRAL]: {
    disabled: ({ theme }: ColorSetProps) => theme.colors.grey10_1,
    background: ({ theme }: ColorSetProps) => theme.colors.grey100_1,
  },
  [MarkerSelectValue.INFORMATIVE]: {
    disabled: ({ theme }: ColorSetProps) => theme.colors.link10,
    background: ({ theme }: ColorSetProps) => theme.colors.link100,
  },
  [MarkerSelectValue.POSITIVE]: {
    disabled: ({ theme }: ColorSetProps) => theme.colors.positive10,
    background: ({ theme }: ColorSetProps) => theme.colors.positive100,
  },
  [MarkerSelectValue.WARNING]: {
    disabled: ({ theme }: ColorSetProps) => theme.colors.warning10,
    background: ({ theme }: ColorSetProps) => theme.colors.warning100,
  },
  [MarkerSelectValue.NEGATIVE]: {
    disabled: ({ theme }: ColorSetProps) => theme.colors.critical10,
    background: ({ theme }: ColorSetProps) => theme.colors.critical100,
  },
};

export interface ItemDimensions {
  width: string;
  height: string;
  innerSize: string;
  hoverSize: string;
}

export const getItemDimensions = (isMarker: boolean): ItemDimensions => ({
  width: isMarker ? '14px' : '28px',
  height: isMarker ? '14px' : '28px',
  innerSize: isMarker ? '14px' : '18px',
  hoverSize: '22px',
});

export interface BackgroundColorProps {
  $marker: MarkerSelectValue;
  theme: DefaultTheme;
  $isDisabled?: boolean;
  $isSelected?: boolean;
}

export const getBackgroundColor = ({ $marker, theme, $isDisabled, $isSelected }: BackgroundColorProps): string =>
  $isDisabled && !$isSelected ? markerColors[$marker].disabled({ theme }) : markerColors[$marker].background({ theme });

export const isMarkerSelectValue = (value?: string): value is MarkerSelectValue =>
  Object.values(MarkerSelectValue).includes(value as MarkerSelectValue);
